import { CurrencyInput } from '../../../../../../components/CurrencyInput';
import { InputBox } from '../../../../../../components/InfoInput';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';

type OutlierPercentageInputProps = {
  id: string;
  label: string;
  description: string;
  value: number | null;
  error?: string;
  onChange: (value: number | null) => void;
  onBlur: () => void;
};

export const OutlierPercentageInput = ({ id, label, description, value, error, onChange, onBlur }: OutlierPercentageInputProps) => {
  return (
    <InputBox className={styles['outliers-percentage-field']}>
      <InputBox.Label htmlFor={id}>{label}</InputBox.Label>
      <div className={styles['outliers-percentage-input']} data-invalid={Boolean(error)}>
        <CurrencyInput
          id={id}
          value={value}
          allowNull
          precision={1}
          decimalSeparator=","
          thousandSeparator="."
          allowNegative={false}
          aria-invalid={Boolean(error)}
          aria-describedby={`${id}-description${error ? ` ${id}-error` : ''}`}
          onChangeValue={onChange}
          onBlur={onBlur}
        />
        <span className={styles['outliers-percentage-input__suffix']} aria-hidden="true">
          %
        </span>
      </div>
      <InputBox.FormDescription id={`${id}-description`}>{description}</InputBox.FormDescription>
      <InputBox.Error id={`${id}-error`} message={error} />
    </InputBox>
  );
};
